import React, { useState } from 'react';

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  CircularProgress,
  Alert,
  DialogContentText,
} from '@mui/material';
import axios from 'axios';
import * as z from 'zod';

import { emailSchema } from '../../utils/validations';

interface RecuperarSenhaProps {
  open: boolean;
  onClose: () => void;
  onTokenSent: () => void;
}

const RecuperarSenha: React.FC<RecuperarSenhaProps> = ({
  open,
  onClose,
  onTokenSent,
}) => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleEnviar = async () => {
    setError('');
    if (!email) {
      setError('Informe seu e-mail cadastrado.');
      return;
    }

    setLoading(true);
    try {
      const url = `${process.env.REACT_APP_OG_API_URL}/usuario-externo/recuperar-senha`;

      await axios.post(url, { email });

      onTokenSent();
      setEmail('');
    } catch (error: any) {
      setError(
        error.response?.data?.message ||
          'Não foi possível enviar o e-mail. Verifique o endereço informado.',
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Recuperação de Senha</DialogTitle>
      <DialogContent>
        <DialogContentText style={{ marginBottom: '1rem' }}>
          Informe o e-mail cadastrado. Enviaremos um código/link para você
          redefinir sua senha.
        </DialogContentText>

        {error && (
          <Alert severity="error" style={{ marginBottom: '1rem' }}>
            {error}
          </Alert>
        )}

        <TextField
          autoFocus
          margin="dense"
          label="E-mail"
          type="email"
          fullWidth
          variant="outlined"
          value={email}
          onChange={e => setEmail(e.target.value)}
        />
      </DialogContent>
      <DialogActions style={{ padding: '16px' }}>
        <Button onClick={onClose} color="inherit">
          Cancelar
        </Button>
        <Button
          onClick={handleEnviar}
          variant="contained"
          color="primary"
          disabled={loading}
        >
          {loading ? <CircularProgress size={24} /> : 'Enviar E-mail'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default RecuperarSenha;
